import type { TranslationKey } from '@shared/constants/translations';
import type { Amenities, Amenity } from '@shared/types/frontend/hotel-card';

const AMENITY_POSITIVE: TranslationKey[] = [
  'free_cancellation',
  'refundable',
  'breakfast_included',
  'half_board',
  'full_board',
  'all_inclusive',
  'RoomRates_option_payOnArrival',
  'Filters_label_POA',
];

const isPositiveAmenity = (amenity: Amenity) =>
  AMENITY_POSITIVE.includes(amenity.name);

const getPositiveAmenities = (amenities: Amenities) =>
  amenities.filter((amenity) => AMENITY_POSITIVE.includes(amenity.name));

const getPositiveAmenitiesEvent = (amenities: Amenities) => {
  const positiveAmenities = getPositiveAmenities(amenities).reduce(
    (acc: string[], cur) => [...acc, cur.name as string],
    [],
  );

  return positiveAmenities.length > 0 ? positiveAmenities.join(',') : undefined;
};

export default getPositiveAmenities;

export { getPositiveAmenitiesEvent, isPositiveAmenity };
